import React from 'react';
import "./Extra.css";
import {HiLocationMarker} from 'react-icons/hi';
import CountUp from 'react-countup';
import {motion} from 'framer-motion';

function Extra() {
  return (
    <section className="extra-wrapper">
        <div className="padding innerWidth flexCenter extra-container">
            <div className="flexColStart extra-left">
                <div className="extra-title">
                    <div className="blueCircle"></div>
                    <motion.h1 
                        initial ={{y: "2rem", opacity: 0}}
                        animate ={{y:0, opacity: 1}}
                        transition = {{
                            duration: 4,
                            type: "ease-in"
                        }}
                    >
                        Discover <br/> Most Suitable <br/> Property
                    </motion.h1>
                </div>
                <div className="extra-des flexColStart">
                    <span className='secondaryText'>Find Beautiful properties that suite you the best</span>
                    <span className='secondaryText'>You will not face any difficulties in finding the best residence for you</span>
                </div>
                <div className="flexCenter search-bar">
                    <HiLocationMarker color="blue" size="25px"></HiLocationMarker>
                    <input type="text" />
                    <button className='button'>Search</button>
                </div>

                <div className="flexCenter stats">
                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={8000} end={9000} duration={3}/>
                            <span>+</span>
                        </span>
                        <span className='secondaryText'>Premium Properties</span>
                    </div>

                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={50} end={100} duration={4}/>
                            <span>+</span>
                        </span>
                        <span className='secondaryText'>Happy Clients</span>
                    </div>

                    <div className="flexColCenter stat">
                        <span>
                            <CountUp start={10} end={30} duration={3}/>
                            <span>+</span>
                        </span>
                        <span className='secondaryText'>Award Winning</span>
                    </div>
                </div>
            </div>

            <div className="flexCenter extra-right">
                <motion.div className="image-container"
                    initial ={{x: "7rem", opacity: 0}}
                        animate ={{x: 0, opacity: 1}}
                        transition = {{
                            duration: 4,
                            type: "ease-in"
                        }}
                >
                    <img src="./main.jpg" alt="main" />
                </motion.div>
            </div>
        </div>
        {/* <a href="" id='back-to-top' className='button button-back-to-top'>&uarr;</a> */}
    </section>
  )
}

export default Extra
